import { instance, next } from "./base";

export const getDashboardRecords = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/dashboard/summary")
    .catch((e) => next(e));
  return data?.data;
};